/**
 * MinisiteView component.
 * @module components/View/MinisiteView
 */
import { useEffect } from 'react';
import { hasBlocksData, getBaseUrl } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { isEqual } from 'lodash';
import { BodyClass } from '@plone/volto/helpers';


const MinisiteView = (props) => {
	const { content, location } = props;
	const path = getBaseUrl(location?.pathname || '');
	const contentLoaded = content && !isEqual(Object.keys(content), ['lock']);
	
	return contentLoaded ? (
		<>
			<BodyClass className='noBreadcrumbs minisite-frontpage' />
			{hasBlocksData(content) && (
				<>
					<div id="minisite-frontpage-container" className='userBlocks' >
						<RenderBlocks {...props} path={path} />
					</div>
				</>
			)}
		</>
	) : null;
};

export default MinisiteView;